import { hasPlatformPermission } from './platformAccess';
import { SUPPORT_TABS } from './supportNav';

/**
 * Tab access for the existing Signal Bridge Support workspace.
 * One permission does not open the other tabs.
 */
export const SUPPORT_TAB_PERMISSIONS = {
  overview: ['platformSupport', 'tenantManagement'],
  support: ['platformSupport'],
  billing: ['billingManagement'],
  'data-usage': ['usageReporting'],
  configuration: ['tenantManagement'],
};

export function supportTabAllowed(subject, tab) {
  const names = SUPPORT_TAB_PERMISSIONS[tab];
  if (!names) return false;
  return names.some((key) => hasPlatformPermission(subject, key));
}

export function visibleSupportTabs(subject) {
  return SUPPORT_TABS.filter((tab) => supportTabAllowed(subject, tab));
}

export function canOpenSupportWorkspace(subject) {
  return visibleSupportTabs(subject).length > 0;
}
